import { render, staticRenderFns } from "./CmgPointsHistoryCell.vue?vue&type=template&id=2079bc2c&scoped=true&lang=pug"
import script from "./cmg-points-history-cell.ts?vue&type=script&lang=ts&external"
export * from "./cmg-points-history-cell.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgPointsHistoryCell.vue?vue&type=style&index=0&id=2079bc2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2079bc2c",
  null
  
)

export default component.exports